import billing from './billing.json';
import common from './common.json';
import contract from './contract.json';
import dashboard from './dashboard.json';
import demo from './demo.json';
import governance from './governance.json';
import member from './member.json';
import menu from './menu.json';
import organization from './organization.json';

export default {
  ...common,
  ...menu,
  ...dashboard,
  ...organization,
  ...contract,
  ...billing,
  ...demo,
  ...member,
  ...governance,
};
